<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
/**
 * @description 主页面
 * @created 2024/04/19 14:27:19
 */
export default {
  name: "App"
}
</script>

<style>
body {
  height: 100vh;
}

#app {
  height: 100%;
}
</style>
